import "../styles/AquaFlowPromo.scss";
import aquaflow from "../assets/marketing/aquaflow.png";
import aquaflow_graph from "../assets/marketing/aquaflow_graph.png";

const AquaFlowPromo = () => {
  return (
    <section className="aqua-flow-promo">
      <img src={aquaflow} alt="Aqua Flow Banner" className="top-image" />

      <div className="features">
        <div>
          <h3>ALTA VAZÃO</h3>
          <p>
            Além de ter sido projetado para movimentar grandes volumes de água,
            o motor conta com o grau de PROTEÇÃO IP44.
          </p>
        </div>
        <div>
          <h3>PRÉ FILTRO</h3>
          <p>
            Ambos modelos possuem um pré-filtro para retenção de sujeiras
            maiores do que 3mm. Eles podem ser conectados a filtros de areia
            proporcionando uma limpeza mais eficaz.
          </p>
        </div>
        <div>
          <h3>MAIS DESIGN</h3>
          <p>
            Com modelos de 1/4CV até 2CV, elas dão suporte para piscinas
            comerciais, residenciais e projetos especiais.
          </p>
        </div>
      </div>

      <div className="button-wrapper">  
        <a
          href={`https://wa.me/555391425203?text=Olá%2C+tenho+interesse+em+seus+serviços+de+${"bombas+de+piscina"}.`}
          target="_blank"
          style={{ color: "inherit" }}
        >
          <button>Solicite seu orçamento</button>
        </a>
      </div>

      <img
        src={aquaflow_graph}
        alt="Gráfico de desempenho"
        className="bottom-image"
      />
    </section>
  );
};

export default AquaFlowPromo;
